import Vue from 'vue';
import staticData from 'tmp/activity-d.json';
import dealerfilter from './dealerInfo.json';
import axios from 'axios';
import Monitor from '@/common/monitor.js'
import {filter, defaultsDeep, forEach, includes, intersectionWith, omit, keys, map, findIndex} from 'lodash';
import {getLocationSearch, getCookie, uuid, getPlatform, setCookie} from '@/common/util';
import {
    getAllProvinceCity,
    getDealerList,
    getUserRight,
    getArticleList,
    getSeriesInfo,
    getPositionInfo,
    getSpecPrice,
    getAllPrice,
    getUserInfo,
    submitLeads,
    getCarInfo,
    getCoupon,
    getCouponNumber,
    getUserRight2,
    costList
} from './api';
import { isAutohomeApp } from '../../../../common/util';
import { alertMessage } from '@/lib/ui';
// PC: 1,  M: 2, APP: 3
const deviceMap = {
    1: 'pc',
    2: 'm',
    3: 'app'
};
export default new Vue({
    created() {
        var n=Math.random();
        // if (n>0.5) {
        //     this.testId = '2020092201';
        // } else {
        //     this.testId = '2020092200';
        // }
        this.init();
    },
    data() {
        const sessionId = getCookie('sessionid');
        return {
            data: staticData,
            dealerfilter: dealerfilter,
            provinceCityInfo: [],
            dealerInfo: {
                dealerList: []
            },
            dealerInfoMsg: '',
            price: {
                normal: {},
                lower: {}
            },
            form: {
                series: {
                    id: '',
                    name: ''
                },
                spec: {
                    id: '',
                    name: ''
                },
                position: {
                    ...staticData.position
                },
                dealers: [],
                mobile: '',
                name: ''
            },
            citys: [
				220100, 210100, 130300, 120100,
				140100, 130100, 370100, 371100,
				610100, 410100, 340100, 320100,
                511300, 420500, 360100, 330100,
                500100, 520300, 430100, 350100
			],
            env: {
                visitId: uuid(),
                device: deviceMap[getPlatform()],
                ip: getCookie('sessionip') || '',
                sessionId: sessionId ? sessionId.split('||')[0] : '',
                source: 2,
                pageType: 3,
                time: Date.now()
            },
            locationSearch: getLocationSearch(),
            locationSearchExtra: omit(this.locationSearch, ['channelId', 'pageId', 'eid', 'site', 'testIdInuse', 'testId', 'pvid', 'adPosId', 'seriesId', 'taskId', 'spec', 'specId']),
            loading: {
                count: 0,
                show: false,
                text: ''
            },
            isUserRightReturn: false,
            userRightArr: [],
            businessType: 4, // 业务id，4为小b平台
            seriesImg: '',
            seriesName: '',
            isShowCoupon: false,//是否显示打车券
            couponValue: '',//金额
            couponMsg: '',
            couponUseTime: '',
            couponId: '',
            isShowSuccessCoupon: false,
            isLoadCoupon: false,
            testId: '',
            //推荐车系列表
            recommendSeriesFixedItems: [],
            isGetJSBridge: false,
            returnBlockShow: false,
            returnBlockArr: [],
            returnMainSeries: '',
            returnMainSeriesName:'',
            returnMainSpec: '',
            returnMainDealerList: [],
            returnBlockMainPrice: {
                normal: {},
                lower: {}
            },
            returnMainSeriesFlag: false,
            positionMatch: false
        };
    },
    computed: {
        head() {
            return this.data.head;
        },
        carSeries() {
            this.getCarInfoFn();
            return this.data.carSeries;
        },
        specification() {
            return this.data.carSeries.specification;
        },
        seriesList() {
            return this.data.carSeries.series.list;
        },
        specList() {
            const spec = filter(this.specification.list, item => item.seriesId === this.form.series.id)[0]; 
            if (spec && spec.specList) {
                return spec.specList;
            }
            return [];
        },
        promotion() {
            return this.data.promotion;
        },
        autoshow() {
            return this.data.autoshow
        },
        information() {
            return this.data.information
        },
        isShowSecondWrap() {
            if(this.citys.indexOf(this.form.position.cityId) > -1) {
                return true;
            } else if (this.information && this.information.list.length && this.information.list[0].publishTime) {
                return true;
            }
            return false;
        }
    },
    methods: {
        getClickMonitorParams() {
            const {channelId = '', pageId = '', eid = '', site = '', testId = '', pvid = '', adPosId = ''} = this.locationSearch;
            const {source, pageType, sessionId, ip, visitId, time, device} = this.env;
            const params = {
                source,
                pageType,
                pvAreaId: eid,
                sessionId,
                u: window.location.href,
                cityId:  this.form.position.cityId,
                seriesId: this.form.series.id,
                specId: this.form.spec.id,
                ip,
                visitId: visitId,
                adposId: adPosId,
                site,
                pvId: pvid,
                pageId,
                channelId,
                testId: testId || this.testId,
                device,
                costTime: Date.now() - time
            };
            return {
                ...params,
                ...omit(this.locationSearchExtra, keys(params))
            };
        },
        getPVMonitorParams() {
            const {channelId = '', pageId = '', eid = '', site = '', testId = '', pvid = '', adPosId = ''} = this.locationSearch;
            const {source, pageType, sessionId, ip, visitId, time, device} = this.env;
            const params = {
                source,
                pageType,
                pvAreaId: eid,
                sessionId,
                cityId: this.form.position.cityId,
                seriesId: this.form.series.id,
                specId: this.form.spec.id,
                ip,
                visitId: visitId,
                pageId,
                channelId,
                adposId: adPosId,
                site,
                device,
                pvId: pvid,
                testId: testId || this.testId,
                costTime: Date.now() - time
            };
            return {
                ...params,
                ...omit(this.locationSearchExtra, keys(params))
            };
        },
        async init() {
            this.initSeries();
            this.initSpec();
            this.getUserInfo();
        },
        initSeries() {
            this.updateSeriesOrder();
            this.form.series.id = this.seriesList[0].id;
            this.form.series.name = this.seriesList[0].name;
            // 初始化，为后期挽留弹窗做准备
            // if(isAutohomeApp) {
                this.returnMainSeries = this.seriesList[0].id;
                this.returnMainSeriesName = this.seriesList[0].name;
            // }
        },
        specInSpecList(id = '') {
            const spec = filter(this.specList, spec => spec.specId.toString() === id.toString())[0];
            if (spec) {
                return spec;
            }
            return null;
        },
        initSpec() {
            let spec = this.specInSpecList(this.locationSearch.specId) || this.specList[0];
            if (spec) {
                this.form.spec.id = spec.specId;
                this.form.spec.name = spec.specName;
            }
            // 在主软中初始化挽留弹窗车型信息
            // if (isAutohomeApp) {
                this.returnMainSpec = spec.specId;
            // }
        },
        updateSeriesOrder() {
            // 将当前seriesId对应的车系放在seriesList第一位
            if (this.locationSearch.seriesId) {
                this.data.carSeries.series.list.sort((a, b) => {
                    if (a.id === this.locationSearch.seriesId) {
                        return -1;
                    }
                    return 0;
                });
            }
        },
        async getAllProvince() {
            return await getAllProvinceCity().then(res => {
                if (res.status === 1 && res.data) {
                    return res.data;
                }
            });
        },
        async updateDealerList() {
            const {series, spec} = this.form;
            const {cityId} = this.form.position;
            if(series.id && spec.id && cityId) {
                const dealerInfo = await this.getDealer(series.id, spec.id, cityId);
                if(dealerInfo.dealerList) {
                    dealerInfo.dealerList = this.unique(dealerInfo.dealerList);
                }
                this.dealerInfo = dealerInfo;
                // 方便查看线上获取到的经销商
                window.dealerInfo = this.dealerInfo;
                if( this.dealerInfo.dealerList && this.dealerInfo.dealerList.length){
                    // this.updateDealer();
                    this.form.dealers = this.dealerInfo.dealerList.slice(0,3);
                    this.dealerInfoMsg = "";
                } else {
                    this.isUserRightReturn = true;
                    this.form.dealers = [];
                    this.dealerInfoMsg = "抱歉，当前城市无可选经销商，请您切换城市进行咨询";
                }
                // 挽留弹窗使用的车型及车系ID，及经销商列表，第一次获取时缓存，以备后续使用
                if (series.id == this.returnMainSeries && spec.id == this.returnMainSpec) {
                    this.returnMainDealerList = this.dealerInfo.dealerList || [];
                }
                this.getUserRightFn();
            }
            
        },
        async updateArticleList() {
            const {cityId} = this.form.position;
            if(!cityId){
                return;
            }
            let list = [];
            try {
                const res = await getArticleList(cityId);
                list = res.data.result;
                this.information.list = list;
            } catch {
               
            }
            
            // 方便查看线上获取到的文章
            window.articleList = this.information.list;
        },
        // updateDealer() {
        //     let {dealerList} = this.dealerInfo;
        //     let dealerNum = 3;
        //     const length = dealerList.length;
        //     if(length >= 3) {
        //         dealerNum = 3;
        //     }else {
        //         dealerNum = length;
        //     }
            
        //     const dealersIndex = [];
        //     while (dealerNum) {
        //         const index = Math.floor(Math.random() * length);
        //         if (!includes(dealersIndex, index)) {
        //             dealersIndex.push(index);
        //             dealerNum--;
        //         }
        //     }
        //     this.form.dealers = map(dealersIndex, index => dealerList[index]);
        //     forEach(this.form.dealers, item => {
        //         let index = findIndex(dealerList, item);
        //         dealerList.splice(index, 1);
        //         dealerList.unshift(item);
        //     })
        //     window.dealers = this.form.dealers;
        // },
        // 去重
        unique(arr){
            let json = {};
            let newArr = [];
            for(var i=0; i<arr.length; i++) {
                let id = arr[i].id;
                if(!json[id]) {
                    json[id] = arr[i];
                    newArr.push(arr[i]);
                }
            }
            return newArr;
        },
        async updatePrice() {
            const {series, spec} = this.form;
            const {cityId} = this.form.position;
            if(!cityId){
                return;
            }
            const data = await this.getPrice(series.id, spec.id, cityId);
            this.price.normal = data[0];
            this.price.lower = data[1];
            // 保留主车系价格，以备后续挽留成功页展示
            if (spec.id == this.returnMainSpec) {
                this.returnBlockMainPrice.normal = data[0];
                this.returnBlockMainPrice.lower = data[1];
            }
        },
        async getDealer(seriesId, specId, cityId) {
            if (seriesId && specId && cityId) {
                return await getDealerList(seriesId, specId, cityId).then(res => {
                    if (res.status === 1 && res.data) {
                        return res.data;
                    }
                });
            }
            return {};
        },
        async costList(params){
            const res = await costList(params);
            return res;
        },
        getSeries(seriesId) {
            getSeriesInfo(seriesId).then(res => {
                if (res.status === 1 && res.data) {
                    // console.log(res);
                }
            });
        },
        // 推荐车系接口聚合
        getRecommendSeriesFixedItems(){
            var _this = this;
            _this.recommendSeriesFixedItems=[];
            var _DATA=_this.data.carSeries.series.list.filter(item => _this.form.series.id.indexOf(item.id) ==-1);
            _DATA.slice(0,5).forEach(function(item , index){
                var seriesId = item.id;
                _this.recommendSeriesFixedItems.push({});
                getCarInfo(seriesId).then(res => {
                    if (res.status == 1 && res.data) {
                        var result = res.data
                        if (result) {
                            result.recoChecked = true;
                            if(index<3){
                                result.checked = true;
                            }else{
                                result.checked = false;
                            }
                            result.dealer = null;
                            _this.$set(_this.recommendSeriesFixedItems, index, result);
                            _this.getRecommendSeriesFixedDealer(result);
                            _this.getRecommendPriceFixed(result);
                        } else {
                            console.log('未获取到车系的详细信息，seriesId:' + _this.seriesId);
                        }
                    }
                })
            })
            // console.log(_this.recommendSeriesFixedItems)
        },
        getReturnBlockArr() {
            var _this = this;
            _this.returnBlockArr = [];
            var _DATA=_this.data.carSeries.series.list.filter(item => item.id != _this.returnMainSeries);
            _DATA.forEach(function(item , index){
                var seriesId = item.id;
                _this.returnBlockArr.push({});
                getCarInfo(seriesId).then(res => {
                    if (res.status == 1 && res.data) {
                        var result = res.data
                        if (result) {
                            result.checked = false;
                            _this.$set(_this.returnBlockArr, index, result);
                            _this.getRecommendSeriesFixedDealer(result);
                            _this.getRecommendPriceFixed(result);
                        } else {
                            console.log('未获取到车系的详细信息，seriesId:' + _this.seriesId);
                        }
                    }
                })
            })
            // console.log('_this.returnBlockArr', _this.returnBlockArr);
        },
        async getRecommendSeriesFixedDealer(seriesItem) {
            var _this = this;
            if (seriesItem.seriesId && seriesItem.specId && this.form.position.cityId) {
                const result = await _this.getDealer(seriesItem.seriesId, seriesItem.specId, this.form.position.cityId);
                if (result) {
                    Vue.set(seriesItem, 'dealerList', result.dealerList)
                } else {
                    seriesItem.dealerList = [];
                    console.log('未获取到推荐车系的详细信息，seriesId:' + _this.seriesId);
                }
            }
        },
        async getRecommendPriceFixed (seriesItem){
            var _this=this;
            if (seriesItem.seriesId && seriesItem.specId && this.form.position.cityId) {
                const result = await _this.getPrice(seriesItem.seriesId, seriesItem.specId, this.form.position.cityId);
                if (result) {
                    Vue.set(seriesItem, 'price', result)
                } else {
                    seriesItem.price = {};
                    console.log('未获取到推荐车系的详细信息，seriesId:' + _this.seriesId);
                }
            }
        },

        async getPrice(seriesId, specId, cityId) {
            if (!seriesId || !specId || !cityId) {
                return {};
            }
            return await axios.all([
                getSpecPrice(seriesId, specId, cityId).then(res => {
                    if (res.status === 1 && res.data) {
                        return res.data;
                    }
                    return {};
                }),
                getAllPrice(specId, cityId).then(res => {
                    if (res.status === 1 && res.data) {
                        return res.data;
                    }
                    return {};
                })
            ]);
        },
        async getUserInfo() {
            let name = getCookie('userName');
            let mobile = getCookie('telphone');
            if (!(/^1\d{10}$/.test(mobile))) {
                const data = await getUserInfo()
                mobile = data.mobilePhone;
                if (!name) {
                    name = data.realName || data.nickName;
                }
            }
            if (name) {
                this.form.name = name;
            }
            if (/^1\d{10}$/.test(mobile)) {
                this.form.mobile = mobile;
            }
        },
        async submit(buttonId, resData) {
            const {channelId = '', pageId = '', eid = '', site = '', testId = '', pvid = '', adPosId = '', taskId = ''} = this.locationSearch;
            const params = {
                u: window.location.href,
                sessionId: this.env.sessionId,
                visitid: this.env.visitId,
                device: this.env.device,
                testid: testId || this.testId,
                pageurlid: pageId,
                adposId: adPosId,
                pvareaid: eid,
                slchanid: channelId,
                pvId: pvid,
                site: site,
                slname: this.form.name.trim(),
                slmobile: this.form.mobile,
                slcity: this.form.position.cityId,
                slprovince: this.form.position.provinceId,
                slcarseries: this.form.series.id,
                slcarspec: this.form.spec.id,
                sldealer: map(this.form.dealers, dealer => {
                    if(dealer.id == 0){
                        return dealer.id + '_' + dealer.deliverId;
                    } else {
                        return dealer.id;
                    }
                    
                }).join(','),
                // dealername: this.form.dealer.name,
                // taskid: taskId || '',
                // taskid: this.form.series.taskid,
                taskid: 1132104,
                outerInfo: JSON.stringify({ belongId: 33}),
                ...this.locationSearchExtra
            };
            if(resData){
                params['def2']= buttonId;
                params['slcarseries']=resData.seriesId;
                params['slcarspec']=resData.specId;
                params['slname'] = this.form.name.trim() || '匿名用户'
                var dealerList =  resData.dealerList || [];
                if (this.positionMatch) {
                    // 如果地址符合备选地址
                    let dealerForChoose = this.dealerfilter.dealerInfos[this.form.position.cityId];
                    // 如果经销商符合备选经销商
                    let dealerIdList = dealerList.map(item => {
                        return item.id;
                    })
                    let idx = this.includes(dealerIdList, dealerForChoose)
                    if (idx.length >= 0) {
                        // 符合条件的备选经销商随机选一个
                        params.sldealer = idx[Math.floor(Math.random() * idx.length)];
                    } else {
                        // 没有符合条件的备选经销商，则在经销商列表里任选一个
                        let dealer = dealerList[Math.floor(Math.random()*dealerList.length)];
                        if (dealer) {
                            if(dealer.id == 0){
                                params['sldealer'] = dealer.id + '_' + dealer.deliverId;
                            } else {
                                params['sldealer'] = dealer.id;
                            }
                        } else {
                            params['sldealer'] = ''
                        }
                    }
                } else {
                    // 如果地址不符合备选地址，随机选一个经销商
                    let dealer = dealerList[Math.floor(Math.random()*dealerList.length)];
                    if (dealer){
                        if(dealer.id == 0){
                            params['sldealer'] = dealer.id + '_' + dealer.deliverId;
                        } else {
                            params['sldealer'] = dealer.id;
                        }
                    } else  {
                        params['sldealer'] = ''
                    }
                }
            }else {
                if (buttonId == 'fixed-button-click') {
                    params['def2'] = 'lcy_FooterSumit_leads';
                } else if (buttonId == 'chuxing-button-click') {
                    params['def2'] = 'lcy_go_out_coupon_leads';
                } else {
                    params['def2'] = 'lcy_leads';
                }
                var dealerArr = filter(this.dealerInfo.dealerList, dealer => {
                    return dealer.id != 0;
                })
                var finaDealerString = map(dealerArr, dealer=> {
                    return dealer.id
                }).join(',');
                this.getCouponFn(this.form.mobile, this.env.sessionId, this.form.position.cityId, finaDealerString, this.env.visitId, this.form.series.id);
            }

            if(buttonId == 'return_block_submit_click') {
                // 默认挽留弹窗提交红旗H5线索
                params.slmobile = getCookie('telphone') || this.form.mobile;
                params.slcarseries = this.returnMainSeries;
                params.slcarspec = this.returnMainSpec;
                params['def2'] = 'return_block_main_leads';
                params.slname = this.form.name.trim() || '匿名用户'
                // 逻辑修改，挽留弹窗主车系不再走备选数据里的经销商，转为与主表单一致的逻辑——上报三个经销商
                params['sldealer'] = map(this.returnMainDealerList.slice(0,3), dealer => {
                    if(dealer.id == 0){
                        return dealer.id + '_' + dealer.deliverId;
                    } else {
                        return dealer.id;
                    }
                }).join(',') || ''

                // if (this.positionMatch) {
                //     let dealerForChoose = this.dealerfilter.dealerInfos[this.form.position.cityId];
                //     if (this.returnMainDealerList.length > 0) {
                //         // 经销商在备选列表里，则随机上报备选数据里的符合条件的经销商
                //         let dealerIdList = this.returnMainDealerList.map(item => {
                //             return item.id;
                //         })                
                //         let idx = this.includes(dealerIdList, dealerForChoose);
                //         if (idx.length >= 0) {
                //             params.sldealer = idx[Math.floor(Math.random() * idx.length)];
                //         } else{
                //             // 经销商列表里没有备选经销商，挑一个经销商上报
                //             let _this = this;
                //             let dealer = _this.returnMainDealerList[Math.floor(Math.random() * _this.returnMainDealerList.length)];
                //             if(dealer.id == 0){
                //                 params['sldealer'] = dealer.id + '_' + dealer.deliverId;
                //             } else {
                //                 params['sldealer'] = dealer.id;
                //             }
                //         }
                //     } else {
                //         params['sldealer'] = ''
                //     }
                // } else {
                //     // 当前地址不在备选列表中，按规定逻辑随机选一个经销商Id上报
                //     let _this = this;
                //     let dealer = _this.returnMainDealerList[Math.floor(Math.random() * _this.returnMainDealerList.length)];
                //     if(dealer.id == 0){
                //         params['sldealer'] = dealer.id + '_' + dealer.deliverId;
                //     } else {
                //         params['sldealer'] = dealer.id || [];
                //     }
                // }
            }

            if (params['slcarseries'] == this.returnMainSeries) {
                this.setReturnData(this.returnMainSeries);
                this.returnMainSeriesFlag = true;
            }

            return await submitLeads({...params, ...omit(this.locationSearchExtra)}).then(res => {
                if (res.status === 0) {
                    return {status: true, pvid: res.pvid};
                }
                return {status: false, msg: res.statusInfo.msg};
            });
        },
        // 设置返回的localStorage
        setReturnData: function (seriesId) {
            var isHaveSeriesId = false;
            if (localStorage.getItem('HQreturnData2')) {
                var returnData = JSON.parse(localStorage.getItem('HQreturnData2'));
                // if (new Date().getTime() > returnData.date) {
                //     isHaveSeriesId = true;
                // }
                for (var i = 0; i < returnData.length; i++) {
                    if (returnData[i].seriesId == seriesId) {
                        isHaveSeriesId = true;
                        returnData[i].date = new Date().getTime() + 60 * 60 * 1000;
                    }
                }

                if (!isHaveSeriesId) {
                    returnData.push({ seriesId: seriesId, date: (new Date().getTime() + 24 * 60 * 60 * 1000) })
                }
                localStorage.setItem('HQreturnData2', JSON.stringify(returnData));
            } else {
                var tmpObj = {
                    seriesId: seriesId,
                    date: (new Date().getTime() + 60 * 60 * 1000)
                }
                var returnData = [tmpObj];
                localStorage.setItem('HQreturnData2', JSON.stringify(returnData));
            }
        },
        includes(arr1, arr2) {
            // 判断arr1是否包含arr2数组的元素
            return arr2.filter(val => {return arr1.indexOf(val)>=0});
        },
        changeLoadingState(showLoading, text) {
            if (showLoading) {
                this.loading.count++;
                this.loading.show = showLoading;
                this.loading.text = text ? text : this.loading.text;
                return;
            }
            if (this.loading.count === 0) {
                this.loading.show = false;
                return;
            }
            this.loading.count--;
            this.loading.show = !!this.loading.count;
        },
        // 获取用户权益信息
        async getUserRightFn() {
            var _this = this;
            var dealerIds = [];
            var returnDealerIds = [];
            if (this.form.dealers) {
                for (var i=0; i<this.form.dealers.length; i++) {
                    dealerIds.push(this.form.dealers[i].id);
                }
            }
            if (this.form.series.id && this.form.spec.id && this.form.position.cityId && dealerIds.length>0) {
                return await getUserRight2(this.form.series.id, this.form.position.cityId, dealerIds.join(',')).then(res => {
                    this.isUserRightReturn = true;
                    this.userRightArr = [];
                    if (res.code == 0 && res.result) {
                        res = res.result;
                        this.isUserRightReturn = true;
                        var tmpUserRrghtArr = [];
                        var tmpObj = {};
                        for (let i = 0; i < res.length; i++) {
                            tmpObj.dealer = res[i].dealerId;
                            if (res[i].activityTheme) {
                                tmpObj.activityTheme = res[i].activityTheme;
                            }
                            if (res[i].activityDesc) {
                                tmpObj.activityDesc = res[i].activityDesc;
                            }
                            returnDealerIds.push(res[i].dealerId);
                            if (res[i].businessType == this.businessType) {
                                for (let k = 0; k < res[i].promotions.length; k++) {
                                    tmpUserRrghtArr.push(res[i].promotions[k]);
                                }
                                tmpObj.rightArr = tmpUserRrghtArr;
                            }
                            if (!tmpObj.rightArr) {
                                tmpObj.rightArr = [];
                            }
                            this.userRightArr.push(tmpObj);
                            tmpObj = {};
                            tmpUserRrghtArr = [];
                        }
                        // 处理有经销商但没有对应权益时，增加经销商
                        if (dealerIds.length !== res.length) {
                            for (var i = 0; i < dealerIds.length; i++) {
                                if (returnDealerIds.indexOf(dealerIds[i]) === -1) {
                                    this.userRightArr.push({
                                        dealer: dealerIds[i],
                                        rightArr: []
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < dealerIds.length; i++) {
                            if (returnDealerIds.indexOf(dealerIds[i]) === -1) {
                                this.userRightArr.push({
                                    dealer: dealerIds[i],
                                    rightArr: []
                                })
                            }
                        }
                    }
                });
            } else {
                this.userRightArr = [];
            }
            return {};
        },
        // 获取车系信息
        async getCarInfoFn() {
            if (this.form.series.id) {
                return await getCarInfo(this.form.series.id).then(res => {
                    if (res.status == 1 && res.data) {
                        this.seriesImg = res.data.seriesImg;
                        this.seriesName = res.data.seriesName;
                    }
                })
            }
            return {};
        },
        // 获取优惠券数量
        async getCouponNumberFn() {
            const { cityId } = this.form.position;
            if (cityId) {
                return await getCouponNumber(cityId).then(res => {
                    if (res.status == 1 && res.data && res.data.result && res.data.result.couponNumber > 0) {
                        this.isShowCoupon = true;
                        this.couponValue = res.data.result.faceValue;
                        this.couponMsg = res.data.result.couponMsg;
                        this.couponUseTime = res.data.result.expTimeLast / 60 / 24;
                        if (this.isLoadCoupon) {
                            return;
                        }
                        this.$clickMonitor.send({
                            buttonId: 'have-load-coupon',
                            ...this.getClickMonitorParams()
                        });
                    } else {
                        this.isShowCoupon = false;
                    }
                })
            }
            return {};
        },
        // 获取优惠券
        async getCouponFn(userPhone, sessionId, cityId, dealers, visitId, seriesId) {
            if (userPhone && sessionId && cityId && dealers && visitId && seriesId && this.isShowCoupon) {
                return await getCoupon(userPhone, sessionId, cityId, dealers, visitId, seriesId).then(res => {
                    if (res.status == 1 && res.data) {
                        if (res.data.returncode == 0) {
                            if (res.data.result.couponReceiver[0].id) {
                                this.couponId = res.data.result.couponReceiver[0].id;
                                this.isShowSuccessCoupon = true;
                                this.$clickMonitor.send({
                                    buttonId: 'success-have-coupon',
                                    ...this.getClickMonitorParams()
                                });
                            }
                        } else {
                            alertMessage(res.data.message);      
                        }
                    }
                })
            }
            return {};
        }
    },
    watch: {
        'dealerInfoMsg': function(newVal) {
            console.log('dealerMsg更新了',newVal);
        },
        'form.series.id': {
            handler: function (val) {
                if (!this.specList || !this.specList.length) {
                    return;
                }
                if (this.specInSpecList(this.form.spec.id)) {
                    return;
                }
                // this.getUserRightFn();
                this.getCarInfoFn();
                this.form.spec.id = this.specList[0].specId;
                this.form.spec.name = this.specList[0].specName;
                // 推荐车系
                this.getRecommendSeriesFixedItems();
            }
        },
        'form.spec.id': function () {
            this.updateDealerList();
            this.updatePrice();
            // this.getUserRightFn();
        },
        'form.position': {
            handler: function(newVal, oldVal) {
                // alert('position更新了' + newVal.cityId + '_' + newVal.cityName);
                if (!newVal.cityId) {
                    return;
                }
                let arr = Object.keys(this.dealerfilter.dealerInfos)
                let positionInArr = findIndex(arr, item => {
                    return item == newVal.cityId
                })
                if(positionInArr >= 0) {
                    this.positionMatch = true;
                } else {
                    this.positionMatch = false;
                }
                this.updateDealerList();
                this.updatePrice();
                this.updateArticleList(); 
                this.getCouponNumberFn();
                // this.getUserRightFn();
                // 推荐车系
                this.getRecommendSeriesFixedItems();
                this.getReturnBlockArr();
            },
            deep: true,
            immediate: true
        },
        'form.mobile': function () {
            if (/^1\d{10}$/.test(this.form.mobile)) {
                setCookie('telphone', this.form.mobile, 365 * 24 * 60 * 60 * 1000);
            }
        },
        'form.name': function () {
            if (this.form.name.trim()) {
                setCookie('userName', this.form.name, 365 * 24 * 60 * 60 * 1000);
            }
        },
        'locationSearch.seriesId': {
            immediate: true,
            handler() {
                this.updateSeriesOrder();
            }
        }
    }
});
